import React from "react";
import { connect } from "react-redux";
import Configuration, { translations } from "../config";
import { NavLink, withRouter } from "react-router-dom";
// Komponenten
import Access from "../components/Access";
import AuthForm from "../components/AuthForm";
import Icon from "../components/Icon";
import QuestionnaireNavLinks from "../plugins/questionnaires/containers/NavLinks";
import ReportsNavLinks from "../plugins/reports/containers/NavLinks";
import QuestionnaireLogo from "../plugins/questionnaires/components/Logo";
import ReportLogo from "../plugins/reports/components/Logo";
// Aktionen
import { loginUser, logoutUser } from "../actions/Users";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

const mapStateToProps = ( state ) =>
{
	return {
		isFetching: state.isFetching
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		loginUser: ( formData ) =>
		{
			dispatch( loginUser( formData ) );
		},
		logoutUser: () =>
		{
			dispatch( logoutUser() );
		}
	};
};

class NavHeader extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			menu: false,
			currentPath: this.props.location.pathname
		};
		
		this.handleMenu = this.handleMenu.bind( this );
		
	} // function constructor(...)
	
	componentDidUpdate()
	{
		if ( this.props.location.pathname !== this.state.currentPath )
		{
			this.setState( { menu: false, currentPath: this.props.location.pathname } );
		}
		
	} // function componentDidUpdate(...)
	
	handleMenu()
	{
		this.setState( { menu: !this.state.menu } );
		
	} // function handleMenu()
	
	renderNavLinks( a_class, a_subLinks )
	{
		let props = {};
		if ( a_class )
		{
			props[ "className" ] = a_class;
		}
		
		return [
			a_subLinks,
			Configuration.pluginName === "questionnaires" && QuestionnaireNavLinks( a_class ),
			Configuration.pluginName === "reports" && ReportsNavLinks( a_class )
		];
		
	} // function renderNavLinks()
	
	render()
	{
		return [
			<nav key={"navbar-top"} className={"navbar-top light-grey black-text"}>
				<div className="progress">
					<div className={`indeterminate ${this.props.isFetching ? "" : "hidden"}`}/>
				</div>
				<article>
					
					{/* SMARTPHONES */}
					<div className={"section smartLogin"}>
						<div className={"col s4 m2"}>
							<button className={"btn-flat primary-color-text hover-secondary-color-text"} onClick={this.handleMenu} title={"Menü anzeigen"}>
								<Icon size={36} key={"menu-icon"} iconName={"menu"}/>
							</button>
						</div>
						<div className={"col s4 m8"}>
							{
								Configuration.pluginName === "questionnaires" &&
								<div className={"logoOuter"}>
									<NavLink className="btn btn-rounded btn-navbar svg" to="/">
										<QuestionnaireLogo topText={"Safety"} bottomText={"Apps"} classNameButton={"btn-flat transparent"} id={"smart"}/>
									</NavLink>
								</div>
							}
							{
								Configuration.pluginName === "reports" &&
								<div className={"reportLogoOuter"}>
									<NavLink className="svg" to="/">
										<ReportLogo classNameButton={"btn-flat transparent"} id={"smartLogo"}/>
									</NavLink>
								</div>
							}
						</div>
						<div className={"col s4 m2"}>
							<AuthForm type={"smart"}/>
						</div>
					</div>
					
					{/* DESKTOP */}
					<div className={"section mainLogin"}>
						<div className={"col s8 l4 navbarBlock"}>
							{this.renderNavLinks( "col s12 position bottom left padding-left" )}
						</div>
						<div className={"col s4 navbarBlock"}>
							{
								Configuration.pluginName === "questionnaires" &&
								<div className={"col offset-m3 m9 offset-l2 l8 offset-xl2 xl6 logoOuter"}>
									<NavLink className="btn btn-rounded btn-navbar svg" to="/">
										<QuestionnaireLogo topText={"Safety"} bottomText={"Apps"} classNameButton={"btn-flat transparent"} id={"deskLogo"}/>
									</NavLink>
								</div>
							}
							{
								Configuration.pluginName === "reports" &&
								<div className={"reportLogoOuter"}>
									<NavLink className="svg" to="/">
										<ReportLogo classNameButton={"btn-flat transparent"} id={"deskLogo"}/>
									</NavLink>
								</div>
							}
						</div>
						<div className={"col l4 navbarBlock loginBlock"}>
							{
								Configuration.pluginName === "reports"
									? <AuthForm type={"tiny"}/>
									: <AuthForm/>
							}
						</div>
					</div>
				
				</article>
			</nav>,
			
			this.state.menu &&
			<ReactCSSTransitionGroup
				component={React.Fragment}
				transitionName="easeIn"
				transitionAppear={true}
				transitionAppearTimeout={500}
				transitionEnter={false}
				transitionLeave={false}>
				<nav key={"navbar-smart"} className={"navbar-smart light-grey"}>
					<article>
						<div className={"white smartMenu"}>
							{
								this.renderNavLinks( "",
									<ul key={"subMenu"} className={"subMenu"}>
										<Access permissions={[ "user_permissions" ]}>
											<li><NavLink to="/passwort-aendern">Passwort ändern</NavLink></li>
										</Access>
										<Access permissions={[ "guest_user_permissions" ]}>
											<li><NavLink to="/passwort-vergessen">Passwort vergessen?</NavLink></li>
											<li><NavLink to={translations.de_DE.routes.registration}>{`Neu ${translations.de_DE.words.toRegistrate}?`}</NavLink></li>
										</Access>
									</ul>
								)
							}
						</div>
					</article>
				</nav>
			</ReactCSSTransitionGroup>
		];
		
	} // function render()
	
} // class

NavHeader = connect(
	mapStateToProps,
	mapDispatchToProps
)( NavHeader );

export default withRouter( NavHeader );